var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgVideo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 284,
    height: 284,
    viewBox: "0 0 284 284",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M173 133.9L142.5 112.6C137.6 109.2 130.9 110.4 127.5 115.3C126.2 117.1 125.6 119.3 125.6 121.5V164C125.6 170 130.4 174.8 136.4 174.8C138.6 174.8 140.8 174.1 142.6 172.9L173.1 151.6C178 148.2 179.2 141.5 175.8 136.6C174.9 135.5 174 134.6 173 133.9Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M146.1 59.6C101.4 59.6 65.1 95.9 65.1 140.6C65.1 185.3 101.4 221.6 146.1 221.6C190.8 221.6 227.1 185.3 227.1 140.6C227.1 95.8 190.8 59.6 146.1 59.6ZM146.1 208.1C108.8 208.1 78.6 177.9 78.6 140.6C78.6 103.3 108.8 73.1 146.1 73.1C183.4 73.1 213.6 103.3 213.6 140.6C213.6 177.8 183.4 208 146.1 208.1Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVideo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/video.056a05a4.svg";
export { ForwardRef as ReactComponent };